import { useEffect } from 'react';
import { InsuranceDetailsForm } from './insurance-details-form.form';
import { InsuranceCardForm } from './insurance-card-form.form';
import { useFormikContext } from 'formik';
import { InsuranceFormType } from '../hooks/use-insurance-form.hook';
import { cashPay } from '../../../Constants';
import { InsuranceSection } from '../Settings/types';

export type InsuranceFormProps = {
  isMobile?: boolean;
  onSelectCashPay: () => void;
  insuranceSection: InsuranceSection;
  patientId: string;
};

export const InsuranceFormBlock: React.VFC<InsuranceFormProps> = ({ isMobile = false, onSelectCashPay, insuranceSection, patientId }) => {
  const formik = useFormikContext<InsuranceFormType>();

  const currentInsuranceId = formik.values.insuranceProvider;

  // if user selects cash pay option as insurance provider,
  // we set the view to delete insurance
  useEffect(() => {
    if (currentInsuranceId === cashPay.id) {
      onSelectCashPay();
    }
  }, [ currentInsuranceId, onSelectCashPay ]);


  return (
    <div>
      <InsuranceDetailsForm insuranceSection={insuranceSection} patientId={patientId} />
      <InsuranceCardForm isMobile={isMobile} gap="24px" mt={3} pr={!isMobile ? 1 : 0} />
    </div>
  );
};
